import { PayloadAction } from 'typesafe-actions';
import {
  ConsolidatedTransactionsProviderState,
  ConsolidatedTransactionsActionTypes,
  ConsolidatedTransactionListFilters,
} from './types';

const ConsolidatedTransactionsReducer = (
  state: ConsolidatedTransactionsProviderState,
  action: PayloadAction<ConsolidatedTransactionsActionTypes, any>,
): ConsolidatedTransactionsProviderState => {
  switch (action.type) {
    case ConsolidatedTransactionsActionTypes.setConsolidatedTransactionListFilters:
      return {
        ...state,
        consolidatedTransactionListFilters: action.payload as Partial<ConsolidatedTransactionListFilters>,
      };
    case ConsolidatedTransactionsActionTypes.setLastPaginationPageVisited:
      return {
        ...state,
        lastPaginationPageVisited: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { ConsolidatedTransactionsReducer };
